var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    { staticClass: "record-button", class: { disabled: _vm.disabled } },
    [
      _vm.isRecording || _vm.isPaused
        ? _c(
            "div",
            { staticClass: "recoding" },
            [
              _c("diV", { staticClass: "record-text" }, [_vm._v("REC")]),
              _c("div", { staticClass: "record-time" }, [
                _vm._v(_vm._s(_vm.recordingFormedTime)),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.isRecording || _vm.isPaused
        ? _c("div", { staticClass: "record-controls" }, [
            _c("ul", { staticClass: "record-control-list" }, [
              _c("li", { staticClass: "record-control-item" }, [
                _vm.isPaused
                  ? _c("button", {
                      staticClass: "record-control-button resume",
                      on: { click: _vm.onRecordResume },
                    })
                  : _vm._e(),
                _vm.isRecording
                  ? _c("button", {
                      staticClass: "record-control-button pause",
                      on: { click: _vm.onRecordPause },
                    })
                  : _vm._e(),
              ]),
              _c("li", { staticClass: "record-control-item" }, [
                _c("button", {
                  staticClass: "record-control-button stop",
                  on: { click: _vm.onRecordStop },
                }),
              ]),
            ]),
          ])
        : _c(
            "div",
            {
              staticClass: "inactive",
              class: { disabled: _vm.disabled },
              on: { click: _vm.onRecordStart },
            },
            [_vm._v("REC")]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }